module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/twitter_page2-C.308bde71.jpg";